import { useState, useCallback } from 'react';

export const useAsyncError = () => {
  const [error, setError] = useState();
  return useCallback(
    (e: any) => {
      setError(() => {
        throw e;
      });
    },
    [setError]
  );
};
